import { TreeNode } from "primereact/treenode";



/**
 * Recursively searches for a tree node with the matching key within the provided collection.
 * @param id Key value to locate.
 * @param items List of nodes to traverse.
 * @returns Matching tree node when found; otherwise undefined.
 */
export const findNode = (id: string | number, items: TreeNode[]): TreeNode | undefined => {
    for (let i = 0; i < items.length; i++) {
        let node = items[i];
        if (node.key === id) {
            return items[i];
        }
        if (node.children) {
            let result = findNode(id, node.children);
            if (result) {
                return result;
            }
        }
    }
    return undefined;
}

/**
 * Locates the parent node containing a child with the specified key.
 * @param id Key value of the target child.
 * @param parents Candidate parent nodes to search.
 * @returns Parent node when a matching child is discovered; otherwise null.
 */
export const findParentNode = (id: string | number, parents: TreeNode[]): TreeNode | null => {


    for (let i = 0; i < parents.length; i++) {
        let node = parents[i];
        if (node.children) {

            for (let j = 0; j < node.children.length; j++) {
                let child = node.children[j];
                if (child.key === id) {
                    return node;
                } else {
                    let result = findParentNode(id, [child]);
                    if (result) {
                        return result;
                    }
                }
            }
        }
    }
    return null;
}

